import React from 'react';

/**
 * RevenueCatIcon - SVG icon for RevenueCat, including background and sizing.
 * @param {object} props - React props (e.g., style, className, width, height)
 */
const RevenueCatIcon = ({
  width = 20,
  height = 20,
  style = {},
  containerStyle = {},
  ...props
}) => (
  <div
    style={{
      backgroundColor: '#f2545b',
      width,
      height,
      borderRadius: 4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...containerStyle
    }}
    className={props.className}
  >
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      <path d="M4.45312 5.14566C5.16339 4.97382 6.26308 4.875 7.25602 4.875C9.93964 4.875 11.5462 5.8091 11.5462 8.18654C11.5462 9.64435 10.9564 10.6061 10.0315 11.1299L12.2702 14.9506C12.0961 15.0765 11.7204 15.1489 11.1968 15.1489C10.607 15.1489 10.2181 15.0784 9.93666 14.9506L8.07303 11.6391H7.85834C7.39636 11.6393 6.9349 11.6063 6.47717 11.5403V14.9651C6.28932 15.0784 5.95416 15.1489 5.47171 15.1489C5.00297 15.1489 4.6541 15.0778 4.45312 14.9651V5.14566ZM6.45202 9.74286C6.83305 9.80919 7.21861 9.84224 7.60478 9.84169C8.77126 9.84169 9.48212 9.40107 9.48212 8.29953C9.48212 7.16652 8.73131 6.70073 7.39069 6.70073C7.07607 6.69926 6.76194 6.72727 6.45202 6.78445V9.74286Z" fill="white" />
      <path d="M20.0873 15.4333C20.0873 17.134 19.2255 17.6013 18.5768 17.9154C16.9205 18.7181 14.2672 17.7844 11.4471 17.5002C8.89369 17.1663 6.36123 16.9464 5.96759 17.519C5.81962 17.664 5.78815 18.1312 5.96759 18.3217C6.49705 18.8836 7.87784 18.4919 8.8556 18.3147C9.15896 18.2669 9.46559 18.3796 9.65998 18.6104C9.85436 18.8411 9.90698 19.1549 9.798 19.4334C9.68902 19.712 9.43501 19.913 9.13165 19.9608C8.68965 20.028 8.24297 20.062 7.79558 20.0625C6.84321 20.0625 5.64571 19.8982 4.96608 19.1752C4.62765 18.8156 4.28093 18.1772 4.54815 17.1781C5.05663 15.2847 8.10033 15.7524 11.6266 16.1078C14.0817 16.355 16.7452 17.1781 17.8094 16.4223C18.0807 16.2297 18.5867 15.7979 18.314 15.4333C18.0412 15.0688 17.5947 15.2664 17.008 15.2664C14.0696 15.2664 12.3393 13.3735 12.3393 10.2148C12.3397 7.84182 13.3207 6.18242 14.9197 5.39484C15.6145 5.05261 16.426 4.875 17.3244 4.875C18.1074 4.875 18.9033 5.01239 19.4114 5.31403C19.7272 5.76711 19.8646 6.57678 19.7956 7.18129C19.1366 6.86561 18.5325 6.70074 17.7501 6.70074C15.814 6.70074 14.4819 7.68933 14.4819 10.0774C14.4819 12.4656 15.7999 13.4132 17.6536 13.4132C18.1813 13.4079 18.8953 13.3439 19.7956 13.2212C19.9901 13.9452 20.0873 14.6826 20.0873 15.4333Z" fill="white" />
    </svg>
  </div>
);

export default RevenueCatIcon; 